class CompleteSet extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const currentState = this.getAttribute('aria-expanded') === 'true'

    this.setAttribute('aria-expanded', !currentState)
  }
}

if (!customElements.get('complete-set')) {
  customElements.define('complete-set', CompleteSet)
}
